export const STALE_TIME = 3 * 60 * 1000; // 3 minute
